import { useEffect, useState } from 'react';
import { RiskScoringTypes } from '../../../../common/aml/types';
import { ClientScoreTypeEnum } from '../../../../../hoc/common/types';

const useRiskScore = ({
  clientScoreType,
  updateIsSuccess,
}: {
  clientScoreType?: ClientScoreTypeEnum;
  updateIsSuccess?: boolean;
}) => {
  const [expandedRows, setExpandedRows] = useState<string[]>([
    RiskScoringTypes.DELIVERY_CHANNEL,
    RiskScoringTypes.GEOGRAPHICAL_RISK,
    RiskScoringTypes.PRODUCTS,
    RiskScoringTypes.TYPE_OF_CLIENT,
    RiskScoringTypes.SOURCE_OF_FUNDS,
    RiskScoringTypes.MONTHLY_VOLUMES,
    RiskScoringTypes.SIC_CODES,
    RiskScoringTypes.DATE_ON_INCORPORATION,
  ]);
  const [blockCollapsed, setBlockCollapsed] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [popupVisible, setPopupVisible] = useState(false);
  const [riskScoreMenuVisible, setRiskScoreMenuVisible] = useState(false);

  const onExpandClick = () => {
    if (expandedRows.length) {
      setExpandedRows([]);
    } else {
      setExpandedRows([
        RiskScoringTypes.DELIVERY_CHANNEL,
        RiskScoringTypes.GEOGRAPHICAL_RISK,
        RiskScoringTypes.PRODUCTS,
        RiskScoringTypes.TYPE_OF_CLIENT,
        RiskScoringTypes.SOURCE_OF_FUNDS,
        RiskScoringTypes.MONTHLY_VOLUMES,
        RiskScoringTypes.SIC_CODES,
        RiskScoringTypes.DATE_ON_INCORPORATION,
      ]);
    }
  };

  useEffect(() => {
    if (updateIsSuccess) {
      setPopupVisible(false);
    }
  }, [updateIsSuccess]);

  useEffect(() => {
    if (clientScoreType === ClientScoreTypeEnum.MANUAL) {
      setBlockCollapsed(false);

      setExpanded(false);
    }
  }, [clientScoreType]);

  return {
    blockCollapsed,
    setBlockCollapsed,
    expanded,
    setExpanded,
    setPopupVisible,
    setRiskScoreMenuVisible,
    riskScoreMenuVisible,
    onExpandClick,
    expandedRows,
    setExpandedRows,
    popupVisible,
  };
};

export default useRiskScore;
